// extracted by mini-css-extract-plugin
export default {"addQuestionModal":"EventQuestion__addQuestionModal__smOQD"};